/*
 *  Product Thumbnail
 *    Contains scripts for the Product Template Qty Selector
 *
 *    Note: Please rebuild me to Process standards once time allows
 *
 *  Version
 *    1.0.0 - 2019/04/17
 */

import $ from 'jquery';
import { generatePicture, generateIcon, addToCart, getCountOfVariantInCart} from './../../process/pc-slate-tools';
import { generatePricing } from './../pricing/ProductPricing';
import { generateLoader } from './../loader/Loader';
// import { Swatch } from '../swatch/Swatch';

export const PRODUCT_THUMBNAIL_SELECTOR = '[data-product-thumbnail]';
export const PRODUCT_SWATCH_BTN = '[data-swatch-object]';
const PRODUCT_SWATCH_SEL = '[data-swatch-selector]';
export const PRODUCT_SWATCH_LABEL = '[data-swatch-label]';
export const PRODUCT_SWATCH_LABEL_PARENT = '[data-swatch-label-parent]';
export const PRODUCT_THUMBNAIL_JSON = '[data-product-thumbnail-json]';
export const PRODUCT_THUMBNAIL_PRICING = '[data-product-thumbnail-pricing]';
export const PRODUCT_THUMBNAIL_ADDCART = '[data-product-thumbnail-addcart]';
export const PRODUCT_THUMBNAIL_ADDCART_LABEL = '[data-product-thumbnail-addcart-label]';
export const PRODUCT_INPUT = '[data-product-thumbnail-input]';
export const PRODUCT_SHOW_OPTIONS = '[data-product-show-options]';
export const PRODUCT_THUMBNAIL_BOTTOM = '[data-product-thumbnail-button]';

export const CLASS_SELECTED = 'is-selected';
export const CLASS_UNAVAILABLE = 'is-not-available';
export const CLASS_ADDED = 'is-added';
const CLASS_PENDING = 'is-pending';
const CLASS_DISABLED = 'is-disabled';
const CLASS_SHOW_OPTIONS = 'is-show-options';

export class ProductThumbnail {
  constructor(container) {
    this.container = container;
    this.swatchButton = container.find(PRODUCT_SWATCH_BTN);
    this.attachEvents();
  }

  attachEvents() {
    this.boundSwatchButton = this.onClickSwatch.bind(this);
    this.boundSwatchSel = this.onChangeSwatch.bind(this);
    this.boundClickAddCart = this.onClickAddCart.bind(this);
    this.boundShowOptions = this.onShowOptions.bind(this);
    this.container.on('click touchend', PRODUCT_SWATCH_BTN, this.boundSwatchButton);
    this.container.on('change', PRODUCT_SWATCH_SEL, this.boundSwatchSel);
    this.container.on('click touchend', PRODUCT_THUMBNAIL_ADDCART, this.boundClickAddCart);
    this.container.on('click touchend', PRODUCT_SHOW_OPTIONS, this.boundShowOptions);
  }

  detachEvents() {
    if(this.boundSwatchButton) this.container.off('click touchend', PRODUCT_SWATCH_BTN, this.boundSwatchButton);
    if(this.boundClickAddCart) this.container.off('click touchend', PRODUCT_THUMBNAIL_ADDCART, this.boundClickAddCart);
    if(this.boundShowOptions) this.container.off('click touchend', PRODUCT_SHOW_OPTIONS, this.boundShowOptions);
  }

  getVariantData(variantId) {
    if(!variantId) return;
    let jsonData = JSON.parse(this.container.find(PRODUCT_THUMBNAIL_JSON).html());
    let v = jsonData.variants.find(v => v.id == variantId);
    return {...v};
  }

  updateImage(imgDiv,varaintImage){;
    if(!varaintImage) return;
    // generate variant picture to the fist product img
    imgDiv.html(generatePicture(varaintImage, 600, [600], 'o-product-thumbnail__image__img-first'));
  }

  updatePrice(price_ele,price,compare_at_price_min){
    price_ele.html(generatePricing(price, compare_at_price_min,'o-product-thumbnail__price'))
  }

  updateLink(a_link,url){
    a_link.attr('href',url)
  }

  updateVariantId(id){
    this.container.find('[name="id"]').val(id);
  }

  updateAddToCart(addcart_button,varaintAvailability){
    // if available
    if (varaintAvailability == true) {
      addcart_button.removeClass(CLASS_UNAVAILABLE);
      addcart_button.removeAttr('disabled');
    } else { // if un available
      if (!addcart_button.hasClass(CLASS_UNAVAILABLE)) {
        addcart_button.addClass(CLASS_UNAVAILABLE);
        addcart_button.attr('disabled','disabled');
      }
    }
  }

  onClickSwatch(e){
    e.preventDefault();
    e.stopPropagation();

    let self = $(e.currentTarget);
    let selfButtons = self.parent().find(PRODUCT_SWATCH_BTN);

    selfButtons.removeClass(CLASS_SELECTED);
    self.addClass(CLASS_SELECTED);

    this.onChangeSwatch(e);
  }

  onChangeSwatch(e) {
    let jsonElement = this.container.find(PRODUCT_THUMBNAIL_JSON);
    let data = JSON.parse(jsonElement.html());
    let self =$(e.currentTarget);
    let selectedDropdown = self.children("option:selected").val();
    let selectParent = self.parent().siblings(PRODUCT_SWATCH_LABEL_PARENT);
    // let selectLabel = selectParent.find(PRODUCT_SWATCH_LABEL);

    let selectedOptions = [];
    for(let i = 0; i < data.options_with_values.length; i++) {
      let o = data.options_with_values[i];
      let swatch = this.container.find('[data-swatch-position="'+o.position+'"]');
      let val = swatch.val();
      if(swatch.length > 1 && !val) {
        swatch = swatch.filter(`.${CLASS_SELECTED}`);
        val = swatch.attr('data-value')
      }
      // multi dropdown
      if (selectedDropdown) {
        let select = this.container.find('[data-swatch-selector][data-index="option'+o.position+'"]');
        let selectedValue = select.children("option:selected").val();
        val = selectedValue;
        // label update
        let selectparent = select.parent().siblings(PRODUCT_SWATCH_LABEL_PARENT);
        // let selectlabel = selectparent.find(PRODUCT_SWATCH_LABEL);
        selectlabel.text(val)
      }
      selectedOptions.push(val);
    }

    let noselectedOptions;
    if(selectedOptions.length == 1){
      if (selectedOptions[0]==undefined){
        noselectedOptions =true
      }
    }


    // for only one select dropdown
    if(selectedDropdown && (noselectedOptions == true)){
      for (let i = 0; i < data.variants.length; i++) {
        let element = data.variants[i];
        let eleTitle = element.title;
        if (eleTitle == selectedDropdown) {
          selectLabel.text(eleTitle)
          this.updateVariantId(element.id);

          // update image
          if (element.featured_image != null && element.featured_image.src != null){
            let img = this.container.find('[data-product-thumbnail-image-first]')
            let elementImage = element.featured_image.src;
            this.updateImage(img, elementImage);
          }

          // update price
          let price_ele = this.container.find(PRODUCT_THUMBNAIL_PRICING);
          this.updatePrice(price_ele,element.price);

          // update link
          let a_link = this.container.find('[data-product-thumbnail-image]');
          let url = data.url+'?variant='+element.id;
          this.updateLink(a_link,url);

          // update add cart button
          let selectecQTY = element.inventory_quantity;
          if (selectecQTY > 0) {
            let selectecAvailability = true;
            let select_addcart_button = this.container.find(PRODUCT_THUMBNAIL_ADDCART);
            this.updateAddToCart(select_addcart_button,selectecAvailability);
            return;
          }
        }
      }
    }

    let variant = data.variants.find(v => selectedOptions.every((so,soi) => v.options[soi] == so));
    if(!variant) {
      let addcart_button = this.container.find(PRODUCT_THUMBNAIL_ADDCART);
      this.updateAddToCart(addcart_button,false);

      // update color label for multi color
      for (let i = 0; i < selectedOptions.length; i++) {
        const element = selectedOptions[i];
        let getSwatch = this.container.find('[data-swatch-group][data-swatch-position="'+(i+1)+'"]');
        let getLabelParent = getSwatch.siblings(PRODUCT_SWATCH_LABEL_PARENT);
        let getLabel = getLabelParent.find(PRODUCT_SWATCH_LABEL);
        getLabel.text(element);
      }

      return;
    }

    if (variant.featured_image != null && variant.featured_image.src != null){
      let img = this.container.find('[data-product-thumbnail-image-first]')
      let variantImage = variant.featured_image.src;
      this.updateImage(img, variantImage);
    }

    // update price
    let price_ele = this.container.find(PRODUCT_THUMBNAIL_PRICING);
    this.updatePrice(price_ele,variant.price,variant.compare_at_price);

    // update link
    let a_link = this.container.find('[data-product-thumbnail-image]');
    let url = data.url+'?variant='+variant.id;
    this.updateLink(a_link,url);

    // update color label
    for(let i = 0; i < variant.options.length; i++) {
      let swatch = this.container.find('[data-swatch-group][data-swatch-position="'+(i+1)+'"]');
      let labelParent = swatch.siblings(PRODUCT_SWATCH_LABEL_PARENT);
      let label = labelParent.find(PRODUCT_SWATCH_LABEL);
      console.log(i, swatch, label, variant.options[i], variant);
      label.text(variant.options[i]);
    }

    // update input variant id
    let id = variant.id;
    this.updateVariantId(id);

    // update add cart button
    if (!selectedDropdown) {
      let variantAvailability = variant.available;
      let addcart_button = this.container.find(PRODUCT_THUMBNAIL_ADDCART);
      this.updateAddToCart(addcart_button,variantAvailability);
    }
  }

  onShowOptions(e){
    e.preventDefault();
    e.stopPropagation();

    let self = $(e.currentTarget);
    let thumbnailBottom = self.closest(PRODUCT_THUMBNAIL_BOTTOM);
    let thumbnail = self.closest(PRODUCT_THUMBNAIL_SELECTOR);

    // if has option
    if(!thumbnailBottom.hasClass('has-options')) return;

    if(!thumbnail.hasClass(CLASS_SHOW_OPTIONS)){
      thumbnail.addClass(CLASS_SHOW_OPTIONS);
    }
    else {
      thumbnail.removeClass(CLASS_SHOW_OPTIONS);
    }
  }

  async onClickAddCart(e){
    e.preventDefault();
    e.stopPropagation();

    let self = $(e.currentTarget);
    let thumbnail = self.closest(PRODUCT_THUMBNAIL_SELECTOR);
    let id = thumbnail.find(PRODUCT_INPUT).val();
    let variant = this.getVariantData(id);

    // Add loader (if necessary)
    let button = this.container.find(PRODUCT_THUMBNAIL_ADDCART);
    let buttonLabel = button.find(PRODUCT_THUMBNAIL_ADDCART_LABEL);
    let loader = button.find('.o-product-thumbnail__loader');
    if(!loader || !loader.length) {
      loader = $(generateLoader(true, 'o-product-thumbnail__loader', '', 20)).appendTo(button);
    }

    /*
      This is a hack so that liquid thumbnails check the cart quantity before
      attempting to add the item to cart
    */
    this.updateButton(variant, id);

    if(button.hasClass(CLASS_DISABLED)) return;

    // Disable
    button.attr('disabled', 'disabled');
    button.addClass(CLASS_DISABLED);
    button.addClass(CLASS_PENDING);


    // Attempt to add to cart
    try {

      // Define preorder line items if needed
      let lineItemProperties = {};
      let isPreorder = variant.inventory_policy == 'continue' && variant.inventory_quantity <= 0;
      if (isPreorder && variant.preorder_message) {
        lineItemProperties[Language.strings['products.product.preorder_property']] = Language.strings['products.product.on_preorder'];
      }

      // Add the item to cart
      await addToCart(id, 1, lineItemProperties);

    } catch(e) {
      // Error, show error, enable buttons hide loader
      console.error('Failed to add to cart.');
      this.updateButton(variant, id);
      return;
    }

    // No error, enable buttons, remove disable class
    button.removeClass(CLASS_PENDING);
    buttonLabel.html(`${Language.strings['products.product.added_to_cart']}`);
    setTimeout(() => this.updateButton(variant, id), 2000);
  }

  updateButton(variant, id) {
    // Adjust the add to cart button based on QTY available and in cart
    let { available, inventory_policy, inventory_management, inventory_quantity } = variant;
    let inCart = getCountOfVariantInCart(id);

    let button = this.container.find(PRODUCT_THUMBNAIL_ADDCART);
    let buttonLabel = button.find(PRODUCT_THUMBNAIL_ADDCART_LABEL);

    if(available) {
      if(inventory_policy != 'continue' && inventory_management != null && (inventory_quantity - inCart) <= 0) {
        available = false;
        buttonLabel.html(`${Language.strings['products.product.all_in_cart']}`);
        button.attr('disabled', 'disabled');
        button.addClass(CLASS_DISABLED);
      } else if(inventory_policy == 'continue' && inventory_management != null && inventory_quantity <= 0) {
        buttonLabel.html(`${Language.strings['products.product.on_preorder']}`);
        button.removeAttr('disabled', 'disabled');
        button.removeClass(CLASS_DISABLED);
      } else {
        buttonLabel.html(`${Language.strings['products.general.add_to_cart_button']}`);
        button.removeAttr('disabled', 'disabled');
        button.removeClass(CLASS_DISABLED);
      }
    } else {
      buttonLabel.html(`${Language.strings['products.product.sold_out']}`);
      button.attr('disabled', 'disabled');
      button.addClass(CLASS_DISABLED);
    }
  }
}

let ACTIVE_THUMBS = [];
export const refreshThumbnails = () => {
  console.log(`Thumbnails Initializing`);

  ACTIVE_THUMBS.forEach(thumb => {
    try {
      thumb.detachEvents();
      thumb = null;
    } catch(e) {
      console.error(e);
    }
  });

  ACTIVE_THUMBS = [];

  $(document).ready($(PRODUCT_THUMBNAIL_SELECTOR).each((e,i) => {
    try {
      let thumb = new ProductThumbnail($(i));
      ACTIVE_THUMBS.push(thumb);
    } catch(e) {
      console.error(e);
    }
  }));

  window.ACTIVE_THUMBS = ACTIVE_THUMBS;
}


//Initialize
$(document).ready(() => refreshThumbnails());
window.refreshThumbnails = refreshThumbnails;
window.getActiveThumbs = () => ACTIVE_THUMBS;